import axios from 'axios';
import { AdminUser } from '../types';
import { API_BASE } from './api';

export const authService = {
  async syncUser(googleUser: any): Promise<AdminUser> {
    const res = await axios.post(`${API_BASE}/auth/syncuser`, {
      idGoogle: googleUser.id || googleUser.sub,
      email: googleUser.email,
      name: googleUser.name,
      givenName: googleUser.given_name,
      familyName: googleUser.family_name,
      picture: googleUser.picture || googleUser.profilePicture,
      locale: 'es',
    });
    return res.data;
  },
};
